import { z } from 'zod';

export const artifactFormatSchema = z.enum(['pdf', 'csv', 'md', 'html', 'xlsx', 'png']);

export type ArtifactFormat = z.infer<typeof artifactFormatSchema>;

export const artifactBlockSchema = z.object({
    type: z.literal('artifact'),
    blockId: z.string(),
    artifactId: z.string(),
    fileName: z.string(),
    format: artifactFormatSchema,
    sizeBytes: z.number().int().nonnegative(),
    expiresAt: z.string(),
});

export type ArtifactBlock = z.infer<typeof artifactBlockSchema>;

export const agentArtifactDownloadResponseSchema = z.object({
    url: z.string(),
});

export type AgentArtifactDownloadResponse = z.infer<typeof agentArtifactDownloadResponseSchema>;
